<template>
  <footer class="footer">Todos Direitos Reservados © {{ year }}</footer>
</template>

<script setup>
let year = new Date().getFullYear();
</script>
